import React, { useState, useEffect, useRef } from 'react';
import 'ol/ol.css';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import CheckIcon from '@mui/icons-material/Check';
import ErrorIcon from '@mui/icons-material/PriorityHigh';
import { Vector } from 'ol/source'
import { toFormatedDate } from 'utils/commonFunc';
import { fromLonLat, toLonLat, get as getProjection } from 'ol/proj';
import Avatar from '@mui/material/Avatar';
import { OverlayContainer } from './layers/OverlayContainerVms';
import { VmsDisplayBox } from 'pages/components/VmsDisplayBox';
import BoundaryPolygonLayer from './layers/BoundaryPolygonLayer';
import BoundaryFacilityStatusLayer from './layers/BoundaryFacilityStatusLayer';
import BoundaryVmsLayer from './layers/BoundaryVmsLayer';
import { Map as OlMap, View } from 'ol';
import { getView, mapProjection, setSourceForGeoJSON, setView } from './OlExtension';

const BoundaryMap = React.forwardRef((props, ref) => {
    const {
        initViewData,
        boundaryGeoJson,
    } = props;

    const divRef = useRef(null);
    const mapObjRefs = useRef(null);
    const overlayContainerRef = useRef(null);

    React.useImperativeHandle(ref, () => ({
        SetVmsItems,
        UpdateFacilityStatus,
    }))

    React.useEffect(() => {
        if (divRef.current) {
            const map = new OlMap({
                target: divRef.current,
                controls: [],
                layers: [],
                view: getView(13, fromLonLat([127.01288, 37.290])),
            })

            mapObjRefs.current = {
                map,
                boundaryLayer: new BoundaryPolygonLayer(map),
                boundaryVmsLayer: new BoundaryVmsLayer(map),
                facilityStatusLayer: new BoundaryFacilityStatusLayer(map),
            };

            return () => map.setTarget(undefined);
        }
    }, [divRef]);

    React.useEffect(() => {
        setView(mapObjRefs.current?.map, initViewData?.zoom, fromLonLat(initViewData?.center))
    }, [initViewData]);

    React.useEffect(() => {
        setSourceForGeoJSON(mapObjRefs.current?.boundaryLayer, boundaryGeoJson)
    }, [boundaryGeoJson]);

    // const SetVmsItems = (items) => {     
    //     console.log('setVmsItems items :::',items);
    //     const boundaryVmsLayer = mapObjRefs.current?.boundaryVmsLayer
    //     if (boundaryVmsLayer) {   
    //         const linkPositionItems = boundaryVmsLayer.createLinkPosition(items)
    //         boundaryVmsLayer.setFeatures(linkPositionItems)

    //         overlayContainerRef.current?.RemoveAll()
    //         linkPositionItems.forEach(item => {
    //             overlayContainerRef.current?.AddOrUpdate(
    //                 item.id,
    //                 item.coordinatePixels[0],                     
    //                 item.positioning,
    //                 () => <VmsDisplayBox item={item} />, 
    //                 (props) => props.id !== item.id
    //                 )  
    //         });
    //     }
    // }
    // 박스위치 이동
    const offsetMap = {
        // 문자 
        
        '청소년문화센터앞': [280, 20],
        '경기대기숙사앞' : [0,0],
        '매탄삼거리': [55, 220],
        '청명역(영통휴먼시아맞은편)' :[5,-130],
        '구법원지하차도': [60, 0],
        '수원역고가동단': [-200, 0],
        '수원버스터미널' : [-200 , 0],
        '서호노인복지관앞' : [-200,0],
        '인계동삼성아파트앞' : [2,0],
        
        //혼합
        '법조타운사거리앞' : [-150,-275],
        '광교마을40단지' : [5,0],
        '신대저수지연화장입구': [0, -20],
        '광교대학로' : [-205,0],
        '광교도서관앞' :[0,-300],
        '합동신학대학교앞' :[145,300],
        '도청로삼거리(동수원)' : [-200,0],

        //도형1
        '금곡칠보마을입구': [-275, 0],
        // '호매실지하차도(IC방향)' :[0,0],
        '숙지중맞은편' :[-50,0],
        '호매실지하차도(수원역방향)' :[220,0],
        '선일초교앞' : [-45,0],
        '호매실지하차도(IC방향)' :[0,40],
        // 금곡로사거리앞

        //도형2
        '율전중삼거리' :[10,0],
        '당수IC' : [-262,0],
        '고색파출소' : [6,0],
        '수원시청' : [272,0],

        //도형3
        '서수원체육공원앞' : [-275,0],
        '삼성삼거리' : [280,0],
        '인계사거리' : [0,0],
        '광교상현IC출구' : [-250, 60],
        '권선지하차도남단' : [30,-50],


    };

    const SetVmsItems = (items) => {
        console.log('setVmsItems items :::', items);

        const boundaryVmsLayer = mapObjRefs.current?.boundaryVmsLayer;
        const map = mapObjRefs.current?.map;

        if (boundaryVmsLayer && map) {
            const linkPositionItems = boundaryVmsLayer.createLinkPosition(items);
            const adjustedLinkPositionItems = linkPositionItems.map(item => {
                const offset = offsetMap[item.name] || [0, 0];

                const pixelCoord = map.getPixelFromCoordinate(fromLonLat(item.coordinatePixels[0]));
                pixelCoord[0] += offset[0];
                pixelCoord[1] += offset[1];
                const adjustedCoord = toLonLat(map.getCoordinateFromPixel(pixelCoord));

                let coordinatePixels = [adjustedCoord];

                // coordinatePixels가 2개일 경우 (꺾인 선)
                if (item.coordinatePixels.length > 1) {
                    const brokenPixelCoord = map.getPixelFromCoordinate(fromLonLat(item.coordinatePixels[1]));
                    brokenPixelCoord[0] += offset[0];
                    brokenPixelCoord[1] += offset[1];
                    const adjustedBrokenCoord = toLonLat(map.getCoordinateFromPixel(brokenPixelCoord));

                    coordinatePixels = [adjustedCoord, adjustedBrokenCoord];
                }

                return {
                    ...item,
                    coordinatePixels
                };
            });

            // 조정된 피처로 설정
            boundaryVmsLayer.setFeatures(adjustedLinkPositionItems);

            overlayContainerRef.current?.RemoveAll();

            adjustedLinkPositionItems.forEach(item => {
                overlayContainerRef.current?.AddOrUpdate(
                    item.id,
                    item.coordinatePixels[0],
                    item.positioning,
                    () => <VmsDisplayBox item={item} />,
                    (props) => props.id !== item.id
                );
            });
        }
    };

    // const SetVmsItems = (items) => {
    //     console.log('setVmsItems items :::', items);

    //     const boundaryVmsLayer = mapObjRefs.current?.boundaryVmsLayer;
    //     if (boundaryVmsLayer) {
    //         const linkPositionItems = boundaryVmsLayer.createLinkPosition(items);

    //         // 중요: 여기서 positioning을 'center'로 명시적으로 설정
    //         const adjustedLinkPositionItems = linkPositionItems.map(item => {
    //             const offset = offsetMap[item.name] || [0, 0];
    //             return {
    //                 ...item,
    //                 positioning: 'center', // 명시적으로 center로 설정
    //                 coordinatePixels: item.coordinatePixels.map(coord => [
    //                     coord[0] + offset[0],
    //                     coord[1] + offset[1]
    //                 ])
    //             };
    //         });

    //         boundaryVmsLayer.setFeatures(adjustedLinkPositionItems);

    //         overlayContainerRef.current?.RemoveAll();

    //         adjustedLinkPositionItems.forEach(item => {
    //             overlayContainerRef.current?.AddOrUpdate(
    //                 item.id,
    //                 item.coordinatePixels[0],
    //                 'center', // 여기서도 'center'로 명시적 설정
    //                 () => <VmsDisplayBox item={item} offset={[0, 0]} />,
    //                 (props) => props.id !== item.id
    //             );
    //         });
    //     }
    // };

    const UpdateFacilityStatus = (geoJson) => {
        const facilityStatusLayer = mapObjRefs.current?.facilityStatusLayer;
        if (facilityStatusLayer) {
            facilityStatusLayer.UpdateFacilityStatus(geoJson)
        }
    }

    return (
        <React.Fragment>
            <div ref={divRef} />
            <OverlayContainer ref={overlayContainerRef} map={mapObjRefs.current?.map} />
        </React.Fragment>
    );
});

export default BoundaryMap;